export const gitCommit = '76c153c3'
